module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-4-1-a22c88dc0346e8004d5add974a9d1ca2.png";